/** @format */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


// Async thunk for fetching stats by game type
export const fetchStats = createAsyncThunk(
  "stats/fetchStats",
  async ({
    gameType,
    gameVariant,
    durationSelectedObj,
    player,
    a23Token,
    accessToken,
  }) => {
    const apiHost = import.meta.env.VITE_REACT_APP_FETCH_USER_STATS;
    const apiPrefix = gameType === "CASH" ? "cash" : "tourney";
    const headers = {
      headers: {
        a23Token: a23Token,
        userId: player?.userId,
        playerName: player?.userName,
      },
    };
    const apiUrl = `${apiHost}/${apiPrefix}?gameVariant=${gameVariant}&dateRangeType=${durationSelectedObj?.dateRangeType}`;

    const response = await axios.get(apiUrl, headers);
    return { gameType, data: response.data };
  }
);

const initialState = {
  cash: {
    data: null,
    loading: false,
    error: null,
  },
  tournaments: {
    data: null,
    loading: false,
    error: null,
  },
};

const statsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {
    clearStats: (state, action) => {
      const gameType = action.payload;
      if (state[gameType]) {
        state[gameType].data = null;
        state[gameType].error = null;
        state[gameType].loading = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStats.pending, (state, action) => {
        const key = action.meta.arg.gameType.toLowerCase();
        if (state[key]) {
          state[key].loading = true;
          state[key].error = null;
        }
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        const { gameType, data } = action.payload;
        const key = gameType.toLowerCase();
        if (state[key]) {
          state[key].loading = false;
          state[key].data = data?.data || {};
        }
      })
      .addCase(fetchStats.rejected, (state, action) => {
        const key = action.meta.arg.gameType.toLowerCase();
        if (state[key]) {
          state[key].loading = false;
          state[key].error = action.error.message;
        }
      });
  },
});

export const { clearStats } = statsSlice.actions;
export default statsSlice.reducer;
